import { InternAccordionDownloadItem } from '../intern/accordion-download-item';
import { ContentIntro } from './intro';

/**
 * Model definition for Accordion-Downloads
 */

export interface ContentAccordionDownload {
  __component: 'content.accordion-download';
  id: string;
  intro?: ContentIntro;
  items: InternAccordionDownloadItem[];
}

export function isContentAccordionDownload(obj: { __component?: string }): obj is ContentAccordionDownload {
  return obj.__component === 'content.accordion-download';
}
